/* eslint no-console:0 */

import '../../assets/stylesheets/utilities';
import '../src/stylesheets';
import '../src/polyfills';

// import "@babel/polyfill";
// import "mutation-observer-inner-html-shim";

require("@rails/activestorage").start();
require('@rails/ujs').start();
import Turbolinks from 'turbolinks';
Turbolinks.start();
window.Turbolinks = Turbolinks;

import '../src/library';
import '../src/elements';

import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';
const application = Application.start();
const context = require.context('../src/controllers', true, /\.js$/);
application.load(definitionsFromContext(context));

const componentRequireContext = require.context('../components', true);
const ReactRailsUJS = require('react_ujs');
ReactRailsUJS.detectEvents();
ReactRailsUJS.useContext(componentRequireContext);

require.context('../images', true);

// import { bulmaCarousel } from 'bulma-carousel';
window.bulmaCarousel = require('bulma-carousel');
// import 'bulma-carousel/dist/js/bulma-carousel'

require("jquery")
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
require("@nathanvda/cocoon")

require('./modal')
